import { t } from "../contract/strings";

/**
 * A duration inside a sentence, in words: "1 minute 5 seconds", "12 seconds", "1 minute".
 *
 * A number standing on its own -- a stat, a timestamp -- keeps the compact "5m 20s"
 * (`fmtMinSec`); a duration a sentence reads aloud is one of the `duration.words_*`
 * plurals. Each picks its form from `count`, which is the seconds (or the minutes when
 * there are none), so one minute has its own key. The core's `duration_words` makes the
 * same choice for the apps. Past an hour it stays in minutes; below zero reads as zero.
 */
export function durationWords(totalSeconds: number): string {
  const total = Math.max(0, totalSeconds);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  if (!minutes) return t("duration.words_seconds", { count: seconds });
  if (!seconds) return t("duration.words_minutes", { count: minutes });
  if (minutes === 1) return t("duration.words_one_minute_seconds", { count: seconds });
  return t("duration.words_minutes_seconds", { minutes, count: seconds });
}
